import { render, staticRenderFns } from "./CreateCard.vue?vue&type=template&id=3c9fa676"
import script from "./CreateCard.vue?vue&type=script&lang=ts"
export * from "./CreateCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports